var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-col',{staticClass:"w-100",attrs:{"lg":"12"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }